import React from 'react';
import { Select } from 'antd';
import { MIN_PLANNING_YEAR } from '../../config/business';
import { buildPlanningYearOptions } from './planningYearOptions';
import styles from '../../styles/components/YearSelector.module.scss';

export interface YearSelectorProps {
  value: number;
  onChange: (year: number) => void;
  startYear?: number;
  yearsCount?: number;
  size?: 'small' | 'middle' | 'large';
  className?: string;
}

export const YearSelector: React.FC<YearSelectorProps> = ({
  value,
  onChange,
  startYear = MIN_PLANNING_YEAR,
  yearsCount,
  size = 'middle',
  className = '',
}) => {
  const options = buildPlanningYearOptions({
    startYear,
    selectedYear: value,
    yearsCount,
  });

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      size={size}
      placeholder="Выберите год"
      className={`${styles.selector} ${className}`}
    />
  );
};


